import React from "react";
import styled from "styled-components";

import { Fonts } from "assets/fonts";

import { Pill, PillProps } from "./Pill";
import { PillStatus, statusPillColors } from "./pill-status";

type StatusPillProps = PillProps & {
  type: PillStatus;
};

const StyledPill = styled(Pill)<StatusPillProps>`
  background-color: ${(p) => p.theme.status[statusPillColors[p.type].bgColor]};
  color: ${(p) => p.theme.status[statusPillColors[p.type].color]};
`;
export const StatusPill: React.FC<StatusPillProps> = (props) => <StyledPill {...props} />;

export const ErrorPill: React.FC<PillProps> = (props) => <StatusPill type="ERROR" {...props} />;
export const SuccessPill: React.FC<PillProps> = (props) => <StatusPill type="SUCCESS" {...props} />;
export const WarningPill: React.FC<PillProps> = (props) => <StatusPill type="WARNING" {...props} />;
export const InfoPill: React.FC<PillProps> = (props) => <StatusPill type="INFO" {...props} />;

const StyledOutlinedPill = styled(Pill)<StatusPillProps>`
  border: 1px solid ${(p) => p.theme.borderHighContrast};
  ${Fonts.semiBold_16}
`;

const StatusBlip = styled.span<{ type: PillStatus }>`
  display: block;
  border-radius: 12px;
  width: 12px;
  height: 12px;
  margin-right: 8px;
  background-color: ${(p) => p.theme.status[statusPillColors[p.type].color]};
`;

export const OutlinedStatusPill: React.FC<StatusPillProps> = (props) => (
  <StyledOutlinedPill {...props}>
    <StatusBlip type={props.type} />
    {props.title}
  </StyledOutlinedPill>
);
